import { render } from "./Errors.vue?vue&type=template&id=4b157a30&ts=true"
import script from "./Errors.vue?vue&type=script&lang=ts"
export * from "./Errors.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/layout/Errors.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4b157a30"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4b157a30', __exports__)) {
    api.reload('4b157a30', __exports__)
  }
  
  module.hot.accept("./Errors.vue?vue&type=template&id=4b157a30&ts=true", () => {
    api.rerender('4b157a30', render)
  })

}


export default __exports__